import { Injectable } from '@angular/core';
import { DocumentRefService } from '@app/core/services/helpers/document-ref.service';

@Injectable()
export class FileManagerService {
    constructor(private documentRefService: DocumentRefService) {}

    download(filename: string, rows: any[], headers?: string[]): void {
        if (!rows || !rows.length) {
            return;
        }
        const separator = ',';
        const keys: string[] = Object.keys(rows[0]);

        if (!headers) {
            headers = keys;
        }

        /* eslint-disable no-control-regex, @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-return */
        const content = `${headers.join(separator)}\n${rows
            .map((row) => {
                return keys
                    .map((key) => {
                        let cell = row[key] === null || row[key] === undefined ? '' : row[key];

                        cell =
                            cell instanceof Date
                                ? cell.toLocaleString()
                                : cell.toString().replace(/"/g, '""');

                        if (cell.search(/("|,|\n)/g) >= 0) {
                            cell = `"${cell}"`;
                        }
                        return cell;
                    })
                    .join(separator);
            })
            .join('\n')}`;
        /* eslint-enable no-control-regex, @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-return */

        const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
        const link = this.documentRefService.createElement('a') as HTMLAnchorElement;
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            this.documentRefService.appendChild(link);
            link.click();
        }
    }
}
